// extracted by mini-css-extract-plugin
export default {"loading":"Components_loading__D7AcV","button":"Components_button__nB5K7"};